import { getUserData } from "api/services/usersServices";
import useAuthStore from "stores/useAuthStore";

export function mapApiUserToAuthUserData(response) {
  return {
    id: response?._id || response?.id,
    email: response?.email,
    role: response?.role,
    position: response?.position,
    country: response?.country,
    company: response?.company,
    modules: response?.modules,
    view_docs: response?.view_docs,
    contract_dept_access: response?.contract_dept_access,
    active: response?.active,
  };
}

export async function refreshAuthUserData(userId) {
  const response = await getUserData(userId);
  const mappedUserData = mapApiUserToAuthUserData(response);
  useAuthStore.getState().setUserData(mappedUserData);
  return mappedUserData;
}
